const getters = {
  getTabs({ nav }) {
    return nav;
  },
  getSelectedTab({ selectedTab }) {
    return selectedTab;
  },
  getPatientRef({ patientData }) {
    return patientData?.ref;
  },
  getPatientData({ patientData }) {
    return patientData;
  },
  getCanManagePatient({ canManagePatient }) {
    return canManagePatient;
  },
  getContent({ content }) {
    return content;
  },
  getOptions({ options }) {
    return options;
  },
  getDataLoading({ getDataLoading }) {
    return getDataLoading;
  },
  getDataSuccess({ getDataSuccess }) {
    return getDataSuccess;
  },
  getLogic({ logic }) {
    return logic;
  },
  getSequenceNumber({ sequenceNumber }) {
    return sequenceNumber;
  },
  getDisabledFormState({ disabledForm }) {
    return disabledForm
  }
};

export default getters;
